export interface LatestRequestToken {
  signal: AbortSignal;
  isCurrent: () => boolean;
}

export interface LatestRequestGate {
  begin: () => LatestRequestToken;
  cancel: () => void;
}

export function createLatestRequestGate(): LatestRequestGate {
  let generation = 0;
  let controller: AbortController | null = null;

  return {
    begin() {
      generation += 1;
      controller?.abort();
      controller = new AbortController();
      const requestGeneration = generation;
      const requestController = controller;

      return {
        signal: requestController.signal,
        isCurrent: () =>
          generation === requestGeneration &&
          controller === requestController &&
          !requestController.signal.aborted
      };
    },
    cancel() {
      generation += 1;
      controller?.abort();
      controller = null;
    }
  };
}
